import SelectCustomizable, { utilsSelectCustomizable } from '__core/modules/atoms/SelectCustomizable';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const UISelectColor = React.forwardRef(({ menuPosition = 'initial', name, onBlur, onChange = () => null, required, value }, ref) => {
  const [defaultValue, setDefaultValue] = React.useState(undefined);
  const data = [
    { guid: 'inherit', name: 'inherit' },
    { guid: 'action', name: 'action' },
    { guid: 'disabled', name: 'disabled' },
    { guid: 'primary', name: 'primary' },
    { guid: 'secondary', name: 'secondary' },
    { guid: 'error', name: 'error' },
  ];
  const options = utilsSelectCustomizable.getOptionsProperties(data, 'name', 'guid');

  React.useEffect(getDefaultValue, [value]);

  function onChangeSelect(event) {
    onChange(event.value);
  }

  function getDefaultValue() {
    const find = options.find((item) => item.value === value);

    if (find) {
      setDefaultValue(find);
    }
  }

  return (
    <SelectCustomizable
      label="Color"
      menuPosition={menuPosition}
      name={name}
      onBlur={onBlur}
      onChange={onChangeSelect}
      options={options}
      required={required}
      value={defaultValue}
    />
  );
});

UISelectColor.propTypes = {
  menuPosition: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.any,
};

export default UISelectColor;
